import { Helmet } from "react-helmet";
import { useLocation } from "react-router-dom";
import metaConfig from "./metaConfig";

const SITE_ORIGIN = "https://srisailamfoundation.org";
const DEFAULT_SOCIAL_IMAGE = `${SITE_ORIGIN}/foundation-icon-512.png`;

export function HelmetWrapper() {
  const { pathname } = useLocation();
  const withoutTrailingSlash = pathname.replace(/\/+$/, "") || "/";
  const meta = metaConfig[withoutTrailingSlash] || metaConfig[`${withoutTrailingSlash}/`];
  const isPrivate = withoutTrailingSlash === "/admin" || withoutTrailingSlash.startsWith("/dashboard");
  const isCoreTeam = withoutTrailingSlash === "/core-team";
  const isNotFound = !meta && !isPrivate;
  const title = isPrivate ? "Administration | Srisailam Foundation" : isNotFound ? "Page Not Found | Srisailam Foundation" : meta.title;
  const description = isPrivate ? "" : isNotFound ? "The requested Srisailam Foundation page could not be found." : meta.description;
  const canonicalUrl = meta ? `${SITE_ORIGIN}${meta.path}` : undefined;

  if (isPrivate || isNotFound) {
    return <Helmet><html lang="en" /><title>{title}</title><meta name="description" content={description} /><meta name="robots" content="noindex, nofollow" /></Helmet>;
  }

  return <Helmet>
    <html lang="en" />
    <title>{title}</title>
    <meta name="description" content={description} />
    {isCoreTeam && <meta name="robots" content="noindex, follow" />}
    <link rel="canonical" href={canonicalUrl} />
    <meta property="og:title" content={meta.title} />
    <meta property="og:description" content={meta.description} />
    <meta property="og:url" content={canonicalUrl} />
    <meta property="og:type" content="website" />
    <meta property="og:site_name" content="Srisailam Foundation" />
    <meta property="og:image" content={DEFAULT_SOCIAL_IMAGE} />
    <meta property="og:image:alt" content="Srisailam Foundation logo" />
    <meta name="twitter:card" content="summary" />
    <meta name="twitter:title" content={meta.title} />
    <meta name="twitter:description" content={meta.description} />
    <meta name="twitter:image" content={DEFAULT_SOCIAL_IMAGE} />
    <meta name="twitter:image:alt" content="Srisailam Foundation logo" />
  </Helmet>;
}
